import { Radio } from "@base-ui/react/radio";
import { RadioGroup } from "@base-ui/react/radio-group";

import { cn } from "../foundations/cn.js";
import { FOCUS_RING, PRESS, PRESS_SCALE } from "../foundations/interaction.js";

export interface QuantitySelectorProps {
  /** The quantities the backend supports, e.g. [1, 2, 3, 5]. */
  options: readonly number[];
  value: number;
  onValueChange: (value: number) => void;
  /** The group's name, e.g. "How many to open". */
  label: string;
  className?: string;
}

/** Picks how many boxes to open at once, directly above the open action. */
export function QuantitySelector({
  options,
  value,
  onValueChange,
  label,
  className,
}: QuantitySelectorProps) {
  return (
    <RadioGroup
      aria-label={label}
      value={String(value)}
      onValueChange={(next) => onValueChange(Number(next))}
      className={cn("grid auto-cols-fr grid-flow-col gap-2", className)}
    >
      {options.map((quantity) => (
        <Radio.Root
          key={quantity}
          value={String(quantity)}
          aria-label={String(quantity)}
          className={cn(
            "inline-flex h-control-md cursor-pointer items-center justify-center rounded-control border border-border-default bg-bg-raised font-mono text-mono-price text-text-secondary tabular-nums",
            "hover:border-border-strong hover:text-text-primary data-checked:border-accent-default data-checked:bg-accent-subtle data-checked:text-accent-text",
            PRESS,
            PRESS_SCALE,
            FOCUS_RING,
          )}
        >
          ×{quantity}
        </Radio.Root>
      ))}
    </RadioGroup>
  );
}
